import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {onlyToast} from 'hiya-common/src/App/CustomToaster'
import {http} from 'hiya-common/src/utils/axios'

export enum PageTypeEnum {
  monster = 0,
  rank,
}
export enum ModalTypeEnum {
  openBox = 1,
  getReward,
  rank20,
}
// 是否可以设置密码 http://wiki.xunlei.cn/pages/viewpage.action?pageId=96440209
export const h5_pwd_info = createAsyncThunk(
  'h5_pwd_info',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'ok' | 'mid' | 'name'>>
    >(
      '/live/account/h5_pwd_info',
      {},
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 是否可以设置密码v2 http://wiki.xunlei.cn/pages/viewpage.action?pageId=151071250
export const h5_set_pwd_v2 = createAsyncThunk(
  'h5_set_pwd_v2',
  async (arg: any, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'ok' | 'err_msg'>>
    >(
      '/live/account/h5_set_pwd_v2',
      {
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 是否可以设置密码 http://wiki.xunlei.cn/pages/viewpage.action?pageId=96440206
export const h5_set_pwd = createAsyncThunk(
  'h5_set_pwd',
  async (arg: {new_pwd: string}, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'ok' | 'err_msg'>>
    >(
      '/live/account/h5_set_pwd',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    const {err_msg = ''} = resp.data.data
    if (err_msg) {
      onlyToast(err_msg)
    }
    return resp.data.data
  }
)

interface InitialStateType {
  ok?: boolean
  mid?: number
  name?: string
  err_msg?: string
}

const initialState: InitialStateType = {}

export const ResetPassWordSlice = createSlice({
  name: 'ResetPassWord',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 主页
    builder.addCase(h5_pwd_info.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default ResetPassWordSlice.reducer
